import React from 'react';
import classNames from 'classnames';
import {Button} from 'react-bootstrap';
import config from '../../../config';
import _ from 'lodash';
import {v4 as uuidv4} from 'uuid';
import RatingScale from 'dashboard/processing/components/RatingScale';

const ConditionMultipleComponent = (props) => {
  const {
    selectedAnswer = {},
    selectedChoices = [],
    Text = '',
    ItemNumber = '',
    QualityCheckImages = [],
    DeterministicQualityCheck = {Choices: []}
  } = props.qualityCheckRecord;
  let {currentStep = '' } = props.qualityCheckRecord;

  if(currentStep == '') {
    currentStep = 'selectChoices';
  }

  const choicesInChunks = _.chunk(DeterministicQualityCheck.Choices, 3);
  const nextStepButtonDisabled = (currentStep == 'selectChoices' && !selectedChoices.length) || (currentStep == 'rateSelectedChoices' && !selectedAnswer.AnswerText);
  return <div className="product-question">
      <div>
        <div className="quality-check-prompt"
             data-item-number={ItemNumber}
             data-testid={`quality-check-prompt-${props.qualityCheckRecord.qualityCheckType}-multipe-choice`}>
          {`${Text} ${config.getEnvironmentName() == 'production' ? '' : ' ' + ItemNumber}`}
        </div>
        {QualityCheckImages.map((image, index) => {
          return (
            <span
              style={{
                'border-radius': 10,
              }}
              key={index}
              className="pright15"
            >
            <img
              className="bot20"
              style={{
                'max-height': 350,
                'max-width': '100%',
              }}
              src={image.URL}
            />
          </span>
          );
        })}
        {currentStep == 'selectChoices' && (
          <div>
            {choicesInChunks.map((choicesInChunk) => {
              return (
                <div
                  key={uuidv4()}
                  style={{flexWrap: 'wrap'}}
                  className={classNames('flex-box', {
                    'space-between': choicesInChunk.length > 1,
                    'justify-content-center': choicesInChunk.length == 1,
                  })}
                >
                  {choicesInChunk.map((label) => {
                    return (
                      <div key={label} style={{width: '30%'}} className="bot8 top8">
                        <Button
                          data-testid={`quality-check-choice-button-${label}`}
                          className={classNames('btn btn-lg quality-check-button', {
                            selected: selectedChoices.includes(label),
                          })}
                          onClick={() => {
                            let dataToUpdate = {selectedChoices};
                            let detailTextToUpdate =  props.screensData.Details || '';
                            if (selectedChoices.includes(label)) {
                              dataToUpdate.selectedChoices = selectedChoices.filter(
                                (item) => item !== label
                              );

                               if(!['other', 'missing pieces'].includes(label.toLowerCase())) {
                                if(detailTextToUpdate.includes(`, ${label}`)) {
                                 detailTextToUpdate = detailTextToUpdate.replace(`, ${label}`, '');
                               } else  if(detailTextToUpdate.match(RegExp(`^${label}`))) {
                                 detailTextToUpdate = detailTextToUpdate.replace(RegExp(`^${label}[,]?\\s?`), '');
                               }
                              }
                             } else {
                              dataToUpdate.selectedChoices.push(label);

                              if(!['other', 'missing pieces'].includes(label.toLowerCase())) {
                                if(!detailTextToUpdate.match(RegExp(`${label}[,]?\\s?`))) {
                                  detailTextToUpdate  = detailTextToUpdate == '' ? label : detailTextToUpdate.concat(', ',label);
                                }
                              }
                            }

                            let data = {
                              dataToUpdate,
                              keepThisQualityCheck: true,
                            };

                            if(( props.screensData.Details || '') !== detailTextToUpdate) {
                              data.detailTextToUpdate = detailTextToUpdate;
                            }

                            props.qualityCheckAnswerHandler(data);
                          }}
                        >
                          <div>
                            <div style={{marginTop: label.toLowerCase() == 'other' ? -5 : 0}}>
                              {label}
                            </div>
                            {label.toLowerCase() == 'other' && (
                              <div className="subtitle">{'please describe below'}</div>
                            )}
                          </div>
                        </Button>
                      </div>
                    );
                  })}
                </div>
              );
            })}
          </div>
        )}
      </div>

      {currentStep == 'rateSelectedChoices' && <RatingScale {...props}></RatingScale>}
      <div className="top30 bot30">{props.displayCustomInputs()}</div>
      <Button
        style={{width: 240}}
        disabled={nextStepButtonDisabled}
        data-testid='quality-check-next-step-button'
        className="btn btn-lg top30 quality-check-button"
        onClick={() => {
              if (currentStep == 'selectChoices') {
                const {AnswerCustomData = {}} = DeterministicQualityCheck.Answers.length ? DeterministicQualityCheck.Answers[0] : {};
                let detailsConditionText =  props.screensData.Details || '';
                const requireDetailsCondition =    selectedChoices.some(choiceLabel => ['other', 'missing pieces'].includes(choiceLabel.toLowerCase()));
               let answerHandlerData = {dataToUpdate: {currentStep: 'rateSelectedChoices'}, keepThisQualityCheck: true};
                if(detailsConditionText == '' && requireDetailsCondition) {
                  answerHandlerData.postingModalTitle = 'Please, specify condition details';
                  answerHandlerData.postingModalConfirmHandler =  _.noop;
                } else  if(AnswerCustomData.MissingPiecesPenalty && selectedChoices.length == 1 && selectedChoices[0].toLowerCase() == 'missing pieces') {
                  const NextQC = DeterministicQualityCheck.Answers.length ? DeterministicQualityCheck.Answers[0].NextQC : false;
                  let penaltyToApply = AnswerCustomData.MissingPiecesPenalty;

                  if(selectedAnswer.AnswerText == 'Missing Pieces selected' ) {
                    penaltyToApply = 'n/a'; /* if user returned back to this Quality Check and only Missing Pieces is selected, do not reduce total rating again */
                  } else if(selectedAnswer.AnswerText && selectedAnswer.Penalty) { /* if user already rated choices earlier, we increase total by this Penalty value back */
                    penaltyToApply = penaltyToApply - selectedAnswer.Penalty;
                  }

                  return props.qualityCheckAnswerHandler({dataToUpdate: {checkedStatus:'passed', selectedAnswer: {
                        ...selectedAnswer, AnswerText:'Missing Pieces selected', Penalty:AnswerCustomData.MissingPiecesPenalty, NextQC
                      }}, penaltyToApply:penaltyToApply});
                }

                props.qualityCheckAnswerHandler(answerHandlerData);
              } else if(currentStep == 'rateSelectedChoices' && selectedAnswer.AnswerText) {
                const NextQC = DeterministicQualityCheck.Answers.length ? DeterministicQualityCheck.Answers[0].NextQC : false;
                  props.qualityCheckAnswerHandler({dataToUpdate: {checkedStatus:'passed', currentStep:'', selectedAnswer: {
                  ...selectedAnswer, NextQC
              }}});
              }
            }}
    >Next Step
    </Button>
  </div>;
};

export default ConditionMultipleComponent;